"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dom_1 = require("./dom");
dom_1.dom.setFeatures(true);
var dom_2 = require("./dom");
exports.DOMImplementation = dom_2.DOMImplementation;
var parser_1 = require("./parser");
exports.DOMParser = parser_1.DOMParser;
var serializer_1 = require("./serializer");
exports.XMLSerializer = serializer_1.XMLSerializer;
//# sourceMappingURL=index.js.map